import { FC, useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Auth from 'store/auth'

import WebinarHeader from 'components/webinar/webinar-future/webinar-header/webinar-header'
import WebinarTemplate from '../../webinar-template/webinar-template'
import WebinarStartInfo from '../webinar-start-info/webinar-start-info'
import Commentaries from 'components/parts/commentaries/commentaries'
import WriteUsBlock from 'components/parts/write-us/write-us-block'
import NMOProgramCards from 'components/nmo-instruction/nmo-program-cards/nmo-program-cards'
import usePCWindow from 'hooks/usePCWindow'

import { deleteAxiosSingle, getAxiosSingle, postAxiosSingle } from 'pages/api/axios'
import { ScreenSize } from 'constants/media-constanst'
import { cutHashFromURL, getParams } from 'utils/getURLData'
import { defineWebinarType } from 'utils/defineWebinarType'
import { AvailableSubscribeStatus, SubscribeStatus, WELCOME_MESSAGE } from 'constants/webinar-data'
import { SubscibeURL } from 'constants/url'
import { IMaterial } from 'constants/types/webinar.types'
import { popupName } from 'constants/auth/auth-data'

import styles from '../webinar-future.module.scss'

const WebinarFutureWrapper: FC<IMaterial> = (data) => {
  const {
    description,
    Lecturs,
    lecturName,
    id,
    startDate,
    linkTranslation,
    points,
    activeNMOCodes,
    Comments,
    NMOTimeLength,
    checkupCount,
    privateKey,
    Specialities,
    expertCouncil,
    hasSponsor,
    ABVersion,
    mandatoryCheckNum,
  } = data
  const router = useRouter()
  const isBigPC = usePCWindow(ScreenSize.big)
  const { isAuthorized } = Auth.useAuth()
  const isSpecsInDescription = description?.includes(WELCOME_MESSAGE) || ''
  const eventTypeLocal = defineWebinarType(id)

  const [status, setStatus] = useState<AvailableSubscribeStatus>(SubscribeStatus.NOT_SUBSCRIBED)
  const [activeButton, setActiveButton] = useState(false)

  const path = cutHashFromURL(router.asPath)
  const subscribeURL = `${SubscibeURL.WEBINAR}/${id}`

  const handleSet = (newStatus: AvailableSubscribeStatus) => {
    const time = newStatus === SubscribeStatus.SUBSCRIBED ? 700 : 2500

    setActiveButton(true)
    setTimeout(() => {
      setStatus(newStatus)
      setActiveButton(false)
    }, time)
  }

  const setSelected = async () => {
    const res = await postAxiosSingle(subscribeURL)
    if (res.status === 201) handleSet(SubscribeStatus.SUBSCRIBED)
  }

  const removeSelected = async () => {
    const res = await deleteAxiosSingle(subscribeURL)
    if (res.status === 200) handleSet(SubscribeStatus.NOT_SUBSCRIBED)
  }

  useEffect(() => {
    const getSubscriptionStatus = async () => {
      const subscription = await getAxiosSingle(subscribeURL)
      if (subscription?.isSubcribed === true) {
        setStatus(SubscribeStatus.SUBSCRIBED)
        return
      }

      //подписка на вебинар через переход из письма
      const parameters = getParams(window.location.href)
      if (parameters?.utm_medium === 'email') {
        return setSelected()
      }
      setStatus(SubscribeStatus.NOT_SUBSCRIBED)
    }

    if (isAuthorized) getSubscriptionStatus()
  }, [isAuthorized, id])

  const handleChangeState = async () => {
    if (!isAuthorized) {
      return router.push(`${path}#${popupName.registration}`, undefined, { shallow: true })
    }

    const isSelected = status === SubscribeStatus.SUBSCRIBED
    isSelected ? removeSelected() : setSelected()
  }
  console.log(data, '535355335')
  return (
    <div>
      <div className={styles.webinarContent}>
        <div className={styles.sidebar}>
          {!isBigPC && <WebinarHeader {...data} />}
          <WebinarStartInfo
            startDate={startDate}
            points={points}
            id={id}
            activeButton={activeButton}
            status={status}
            handleChangeState={handleChangeState}
          />
        </div>
        <div className={styles.descriptionWrapper}>
          {isBigPC && <WebinarHeader {...data} />}
          <div>
            <WebinarTemplate
              id={id}
              linkTranslation={linkTranslation}
              points={points}
              ABVersion={ABVersion}
              NMOTimeLength={NMOTimeLength}
              isActiveNMOCodes={Boolean(activeNMOCodes)}
              checkupCount={checkupCount}
              privateKey={privateKey}
              Specialities={isSpecsInDescription ? undefined : Specialities}
              Lecturs={Lecturs}
              lecturName={lecturName}
              eventType={eventTypeLocal}
              hasSponsor={hasSponsor}
              mandatoryCheckNum={mandatoryCheckNum}
              expertCouncil={expertCouncil}
              description={description}
              modificator={styles.templateModificator}
              withAcordeons
            />
          </div>
          <NMOProgramCards firstCourse={2} secondCourse={1} />
          <div className={styles.commentariesBottom}>
            <Commentaries
              comments={Comments}
              id={id}
              materialType="webinar"
              isWithNMO={Boolean(activeNMOCodes)}
            />
            <WriteUsBlock />
          </div>
        </div>
      </div>
    </div>
  )
}

export default WebinarFutureWrapper
